import strings from 'strings/strings.json';
import { FlexColSm } from 'components/Elements';
import TextField from 'components/forms/TextField';
import { createErrorMessage, fieldErrorCodes, requiredFieldErrorMessage } from 'shared/error-messages';
import { validateThreeCharacterLimit } from 'lib/custom-form-validation';

type BaseDetailsFormProps = {
    register: any;
    errors: any;
    autoFocus?: boolean;
    hideShortDescription?: boolean;
    hideDuration?: boolean;
};

export default function BaseDetailsForm({
    register,
    errors,
    autoFocus = false,
    hideShortDescription = false,
    hideDuration = false,
}: BaseDetailsFormProps): JSX.Element {
    const titleMaxLength = 120;
    const descriptionMaxLength = 120;

    return (
        <FlexColSm>
            <TextField
                fieldName="activityTitle"
                maxLength={titleMaxLength}
                labelText={strings.activityDetailsForm.titleInputLabel}
                inputAria={strings.activityDetailsForm.titleInputAria}
                errorMessage={errors.title?.message}
                required
                autoFocus={autoFocus}
                {...register('title', {
                    required: {
                        value: true,
                        message: requiredFieldErrorMessage(strings.activityDetailsForm.titleInputLabel),
                    },
                    maxLength: {
                        value: titleMaxLength,
                        message: createErrorMessage(
                            strings.activityDetailsForm.titleInputLabel,
                            fieldErrorCodes.maxLength,
                        ),
                    },
                })}
            />

            {/* Optional short description field */}
            {!hideShortDescription && (
                <TextField
                    fieldName={strings.activityDetailsForm.descriptionInputLabel}
                    maxLength={descriptionMaxLength}
                    labelText={strings.activityDetailsForm.descriptionInputLabel}
                    inputAria={strings.activityDetailsForm.descriptionInputAria}
                    errorMessage={errors.description?.message}
                    required
                    {...register('description', {
                        required: {
                            value: true,
                            message: requiredFieldErrorMessage(strings.activityDetailsForm.descriptionInputLabel),
                        },
                        maxLength: {
                            value: descriptionMaxLength,
                            message: createErrorMessage(
                                strings.activityDetailsForm.descriptionInputLabel,
                                fieldErrorCodes.maxLength,
                            ),
                        },
                    })}
                />
            )}

            {/* Optional duration field */}
            {!hideDuration && (
                <TextField
                    fieldName="activityTaskDuration"
                    maxLength={3}
                    labelText={strings.activityDetailsForm.durationInputLabel}
                    inputAria={strings.activityDetailsForm.durationInputAria}
                    errorMessage={errors.durationInMins?.message}
                    type="number"
                    width="8rem"
                    unitText={strings.activityDetailsForm.durationInputMins}
                    required
                    {...register('durationInMins', {
                        required: {
                            value: true,
                            message: requiredFieldErrorMessage(strings.activityDetailsForm.durationInputLabel),
                        },
                        validate: {
                            validateThreeCharacterLimit,
                        },
                        maxLength: {
                            value: 3,
                            message: createErrorMessage(
                                strings.activityDetailsForm.durationInputLabel,
                                fieldErrorCodes.maxLength,
                            ),
                        },
                    })}
                />
            )}
        </FlexColSm>
    );
}
